import { Link } from "react-router-dom";
import "../styles/about.css";

export default function About() {
  return (
    <div className="about-page">
      {/* About Section */}
      <section className="about-us">
        <div className="container about-content">
          <div className="about-text">
            <h2 className="section-heading">About Us</h2>
            <p>
              At <strong>Mediasha Services Pvt. Ltd.</strong>, we believe in transforming the healthcare sector with innovative technology. Our vision is to deliver state-of-the-art, globally accepted products and services that improve patient care, simplify medical processes, and enhance efficiency in healthcare centers.
            </p>
            <p>
              With a strong emphasis on quality and affordability, we aim to build a seamless connection between technology and healthcare. We specialize in providing modern solutions for hospitals, clinics, and medical practitioners to help them serve their patients better.
            </p>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="our-vision mission-vision-section">
        <div className="container">
          <div className="vision-content">
            <h2 className="section-heading">Our Vision</h2>
            <p>
              To be a global leader in healthcare technology solutions, delivering reliable, innovative, and cost-effective products that empower healthcare professionals to improve patient outcomes and streamline medical operations.
            </p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="our-mission mission-vision-section">
        <div className="container">
          <div className="mission-content">
            <h2 className="section-heading">Our Mission</h2>
            <ul className="mission-list">
              <li>Provide high-quality, technology-driven healthcare solutions at competitive prices.</li>
              <li>Enhance patient care through innovative medical devices and digital healthcare solutions.</li>
              <li>Offer exceptional support and services, ensuring customer satisfaction.</li>
              <li>Continuously upgrade our products with the latest advancements in medical technology.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-us">
        <div className="container">
          <h2 className="section-heading centered">Why Choose Us?</h2>
          <ul className="benefits-list">
            <li>✔ <strong>Internationally Recognized Products</strong> – We deliver globally trusted healthcare solutions.</li>
            <li>✔ <strong>Affordable & Reliable</strong> – High-quality products at competitive prices.</li>
            <li>✔ <strong>Expert Support</strong> – Dedicated customer service and technical help.</li>
            <li>✔ <strong>Innovative Solutions</strong> – Technology-first healthcare tailored to your needs.</li>
          </ul>
          <p className="company-commitment">
            At <strong>Mediasha Services Pvt. Ltd.</strong>, we're more than a service provider — we're your partner in healthcare innovation.
          </p>
          <p className="cta-text">Let’s build a healthier future together!</p>
          <p className="contact-cta">
            📩 <Link to="/contact-us" className="contact-link">Contact Us</Link> to learn more about our solutions.
          </p>
        </div>
      </section>
    </div>
  );
}
